@if (visible()) {
  <div
    class="message-contextuel"
    [class]="type()"
    [attr.role]="role()"
    [attr.data-tfa]="'message-contextuel-' + type()"
  >
    @if (showIcon()) {
      <span
        class="message-contextuel__icone"
        [class.message-contextuel__icone--remontee]="glypheARemonter()"
        aria-hidden="true"
      >
        <mat-icon>{{ glyphe() }}</mat-icon>
      </span>
    }

    <div class="message-contextuel__texte">
      @if (message(); as libelle) {
        {{ libelle }}
      }
      <ng-content></ng-content>
    </div>

    @if (closable()) {
      <button
        type="button"
        class="message-contextuel__fermer"
        [attr.aria-label]="closeLabel()"
        (click)="close()"
        data-tfa="message-contextuel-fermer"
      >
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
    }
  </div>
}
